<mfe-loader module-name="@onvio/notification" class="ng-bento notification-loader"></mfe-loader>